import dynamic from 'next/dynamic';
const Chart = dynamic(() => import('react-apexcharts'), { ssr: false });
import { Alert } from 'react-bootstrap';

export default function YatirimciSayisiGrafik({ yatirimciSayisi }) {

  if (!yatirimciSayisi || yatirimciSayisi.length === 0) {
    return(
      <div className='p-4 pt-2'>
        <Alert variant='warning'>
          Yatırımcı sayısı verileri mevcut değil.
        </Alert>
      </div>
    );
  }

  const yatirimciSayisiChartOptions = {
    chart: {
      id: 'yatirimci-id',
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    colors : ['#0EA5E9'],
    xaxis: {
      categories: yatirimciSayisi.map(data => data.tarih),
      labels: {
        show: false
      },
      axisTicks: {
        show: false
      },
      axisBorder: {
        show: false
      }
    },
    yaxis: {
      labels: {
        show: false
      }
    },
    grid: {
      show: false  // Arka plandaki grid çizgilerini kaldırır
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth',
      width: 2,
      lineCap: 'round',
      show: true,
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: 'light',
        shadeIntensity: 0.6,
        opacityFrom: 0.6,
        opacityTo: 0,
      }
    },
  };

  const yatirimciSayisiChartSeries = [{
    name: 'Yatırımcı Sayısı',
    data: yatirimciSayisi.map(data => parseFloat(data.sayi))
  }];

  return(
    <div className='p-sm-0 p-lg-4 pt-0'>
      <Chart
        options={yatirimciSayisiChartOptions}
        series={yatirimciSayisiChartSeries}
        type='area'
        width='100%'
        height='300'
      />
    </div>
  );
}